import {create_title} from '../../base/titleData'
import pageData from '../../base/pageData'
import { box_shadow_style_add, getBackgroundData, getSwiperSettingData, fontSet, basic_product_display_new_style, getCommonStyle} from "@/base/widgets_data_compatible";

export default {
  version: 1.1,
  img_effects: {
    id: 1,
    formData: {
      effect: 0, // 当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
  },
  mb_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
  },
  pc_widgets_infor: {
    descNum:57, // 简介显示字数
    page: pageData,
    title: create_title('Article list'),
    textAlign:'left',
    // 图片高度
    imgHeight: {
      radioVal: 'default',
      default: {
        height: '58%'
      },
      custom: {
        height: '58%'
      }
    },
    // 图片宽度
    imgWidth: {
      radioVal: 'default',
      default: {
        width: '38%'
      },
      custom: {
        width: '38%'
      }
    },
    // 每行个数
    colNum: {
      radioVal: 'default',
      default: {
        value: 2
      },
      custom: {
        value: 4
      }
    },
    borderRadius: {
      ...getCommonStyle().borderRadius
    },
    // 显示个数
    showNum: 1,
    showAll: true,
    moduleStyle: '1',
    showSet: ['date', 'type', 'summary', 'button'],
    jumpWay: 'newWindow',
    cate_cont_show: 'true', //分类是否显示
    backgroundSize: { // 图片缩放
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },
    // 图片间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: 20,
        paddingLeft: 20,
      },
      custom: {
        paddingTop: 20,
        paddingLeft: 20,
      }
    },
    // 组合阴影 4.6.7
    ...getBackgroundData(),
    ...box_shadow_style_add(),
    ...getSwiperSettingData(),
    font:{
      ...fontSet(),
      default: {
        ...fontSet().default,
        fontSize: 16
      },
      custom: {
        ...fontSet().custom,
        fontSize: 16
      }
    },
    ...basic_product_display_new_style(),
  },
  mb_widgets_infor: {
    // page: pageData,
    title: create_title('Article list'),
    // 每行个数
    colNum: {
      radioVal: 'default',
      default: {
        value: 2
      },
      custom: {
        value: 2
      }
    },
    moduleStyle: '1'
  },
  listArr: {
    moduleState: 'list', // list // 文章列表， type // 文章类型列表
    articleList: [],
    addArticleType: 'id', // 直接添加，筛选条件
    sortBy: 'default',
    sort: 'desc', // asc desc
    filterBy: [], // 筛选条件
    type: 1,
    sys_type: 0, // 5.1.0 系统推荐区分类型
    thumbnailWidth: '',
    type_system: true // 4.7.18 数据来源是否有系统推荐
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_article_list/style.js